import { Outlet, NavLink } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useUser, canAccess } from '../lib/auth'
import styles from './Layout.module.css'
import logo from '../../images/schild-flaggen-logo-1.png'

export default function Layout() {
  const { logout, user: auth0User } = useAuth0()
  const { user } = useUser()

  function handleLogout() {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <nav className={styles.nav}>
          <NavLink
            to="/orders"
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            Aufträge
          </NavLink>
          <NavLink
            to="/design"
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            Design
          </NavLink>
          <NavLink
            to="/produktion"
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
          >
            Produktion
          </NavLink>
          {(!user || canAccess(user, 'invoices')) && (
            <NavLink
              to="/invoices"
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.active}` : styles.link
              }
            >
              Rechnungen
            </NavLink>
          )}
          {(!user || canAccess(user, 'clients')) && (
            <NavLink
              to="/clients"
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.active}` : styles.link
              }
            >
              Kunden
            </NavLink>
          )}
          {(!user || canAccess(user, 'flags')) && (
            <NavLink
              to="/flags"
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.active}` : styles.link
              }
            >
              Flaggen
            </NavLink>
          )}
          {(!user || canAccess(user, 'archive')) && (
            <NavLink
              to="/archive"
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.active}` : styles.link
              }
            >
              Archiv
            </NavLink>
          )}
          {(!user || canAccess(user, 'management')) && (
            <NavLink
              to="/management"
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.active}` : styles.link
              }
            >
              Management
            </NavLink>
          )}
          {(!user || canAccess(user, 'users')) && (
            <NavLink
              to="/users"
              className={({ isActive }) =>
                isActive ? `${styles.link} ${styles.active}` : styles.link
              }
            >
              Administrator
            </NavLink>
          )}
        </nav>
        <div className={styles.userBlock}>
          <div className={styles.userName}>
            {user?.name ?? auth0User?.name ?? '—'}
          </div>
          <div className={styles.userEmail}>
            {user?.email ?? auth0User?.email ?? ''}
          </div>
          {user?.roles && (
            <div className={styles.userRoles}>
              Rollen: {user.roles.map((r) => ({
                admin: 'Administrator',
                sales: 'Vertrieb',
                fulfillment: 'Auftragsabwicklung',
                accounting: 'Buchhaltung',
                design: 'Design',
                management: 'Management',
              }[r] ?? r)).join(', ')}
            </div>
          )}
          <button
            className={`btn btn-secondary ${styles.logoutBtn}`}
            onClick={handleLogout}
          >
            Abmelden
          </button>
        </div>
      </aside>

      <main className={styles.main}>
        <div className={styles.topRightLogo}>
          <img src={logo} alt="Intranet logo" className={styles.topRightLogoImg} />
        </div>
        <Outlet />
      </main>
    </div>
  )
}
